import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetSponsoredSectionsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/advertisement/service.types';
import React from 'react';
import {SearchSuggestSponsoredSlider} from '../../features/SearchSuggestSponsoredSlider';
import {useGetSearchSuggestCampaignsRequest} from './useGetSearchSuggestCampaignsRequest';

export interface SearchSuggestCampaignsFetcherViewProps {
  hideButtonControls?: boolean;
  className?: string;
  onTeaserClick?: () => void;
}

const SearchSuggestCampaignsSliderView: React.FC<
  GetSponsoredSectionsResponse & SearchSuggestCampaignsFetcherViewProps
> = ({section, hideButtonControls, className, onTeaserClick}) => {
  if (!section?.length) {
    return null;
  }
  return (
    <SearchSuggestSponsoredSlider
      campaigns={section}
      hideButtonControls={hideButtonControls}
      className={className}
      onTeaserClick={onTeaserClick}
    />
  );
};

export const SearchSuggestCampaignsFetcher: React.FC<
  SearchSuggestCampaignsFetcherViewProps & {
    onTeaserClick?: () => void;
  }
> = ({hideButtonControls, className, onTeaserClick}) => {
  const request = useGetSearchSuggestCampaignsRequest();

  return (
    <DataFetcher
      request={request}
      View={SearchSuggestCampaignsSliderView}
      viewProps={{hideButtonControls, className, onTeaserClick}}
      Error={null}
    />
  );
};
